import { render } from "./Blogger.vue?vue&type=template&id=724445a7&scoped=true"
import script from "./Blogger.vue?vue&type=script&lang=js"
export * from "./Blogger.vue?vue&type=script&lang=js"

import "./Blogger.vue?vue&type=style&index=0&id=724445a7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724445a7"]])

export default __exports__